import React, { PureComponent } from 'react';
import '../../../style/Header.css';

export default class ShareInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { value: '' };

    this.handleFocus = this.handleFocus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleFocus(event) {
    this.props.handleClick();
  }

  handleSubmit(e) {
    if (e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 188 || e.type === 'blur') {
      const val = e.target.value.trim();

      if (val !== '') {
        this.props.handleKeyPress(val);
      }
      this.setState({ value: '' });
    } else {
      const val = e.target.value.trim();
      this.setState({ value: val });
    }
  }

  render() {
    return (
      <input
        type="text"
        value={this.state.value}
        placeholder="Add people..."
        className="add-email-input"
        onFocus={this.handleFocus}
        onChange={this.handleChange}
        onKeyDown={this.handleSubmit}
        onBlur={this.handleSubmit}
      />
    );
  }
}
